function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react'; // original author: vlin

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { HotKeys } from 'react-hotkeys';
import Tooltip from './Tooltip';
import { getAdditionalProps } from '../utils/propTypes';
import onClickOutsideHOC from '../utils/onClickOutsideDecorator';
import { TOOLTIP_CONTENT_PROPTYPE, ARROW_LOCATION_PROPTYPE, STYLE_PROPTYPE } from './constants';
import { HIDE_CHILD, SHOW_CHILD } from '../hotKeys/constants';
import { ACTION_KEY_MAP } from './hotKeys';
/**
* withTooltip is an HOC that provides the wrappedComponent with a tooltip.
*
* To use the HOC, wrap the component like so:
*   let ButtonWithTooltip = withTooltip(Button);
*
* Then, provide the following props through the wrappedComponent
*
* e.g. <ButtonWithTooltip tooltipText="A button"> This is Button Text </ButtonWithTooltip>
* 1) tooltipText - required
* 2) arrowLocation - optional
* 3) tooltipStyle - optional
*
* @summary An HOC that provides the wrappedComponent with an accompanying tooltip
*/

var withTooltip = function withTooltip(Component) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(WithTooltipWrapper, _PureComponent);

    function WithTooltipWrapper() {
      var _getPrototypeOf2, _defineProperty2;

      var _this;

      _classCallCheck(this, WithTooltipWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithTooltipWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "state", {
        targetNode: null
      });

      _defineProperty(_assertThisInitialized(_this), "hotKeyHandlers", (_defineProperty2 = {}, _defineProperty(_defineProperty2, HIDE_CHILD, function () {
        return _this._handleKeyPressedHide();
      }), _defineProperty(_defineProperty2, SHOW_CHILD, function (e) {
        return _this._handleFocus(e);
      }), _defineProperty2));

      _defineProperty(_assertThisInitialized(_this), "_handleMouseOver", function (e) {
        _this._mouseOverNode = true;

        _this._handleShow(e);
      });

      _defineProperty(_assertThisInitialized(_this), "_handleMouseLeave", function () {
        _this._mouseOverNode = false;

        if (!_this._nodeFocused && !_this._mouseOverNode) {
          _this._handleHide();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_handleFocus", function (e) {
        _this._nodeFocused = true;

        _this._handleShow(e);
      });

      _defineProperty(_assertThisInitialized(_this), "_handleKeyPressedHide", function () {
        if (_this._nodeFocused || _this._mouseOverNode) {
          _this._nodeFocused = true;
          _this._mouseOverNode = false;

          _this._handleHide();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_handleReset", function () {
        if (_this._nodeFocused || _this._mouseOverNode) {
          _this._nodeFocused = false;
          _this._mouseOverNode = false;

          _this._handleHide();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_handleBlur", function () {
        _this._nodeFocused = false;

        if (!_this._nodeFocused && !_this._mouseOverNode) {
          _this._handleHide();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_handleShow", function (e) {
        _this.setState({
          targetNode: e.currentTarget
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_handleHide", function () {
        _this.setState({
          targetNode: null
        });
      });

      return _this;
    }

    _createClass(WithTooltipWrapper, [{
      key: "render",
      value: function render() {
        var targetNode = this.state.targetNode;
        var _this$props = this.props,
            tooltipId = _this$props.tooltipId,
            tooltipText = _this$props.tooltipText,
            tooltipArrowLocation = _this$props.tooltipArrowLocation,
            tooltipStyle = _this$props.tooltipStyle,
            __containerClassName = _this$props.__containerClassName;
        var componentProps = getAdditionalProps(this);
        var tooltipClasses = classNames('eds-tooltip--hoc-wrapper', __containerClassName);
        var describedBy; // We don't want `aria-describedby` on the div when no tooltip is
        // present

        if (targetNode) {
          describedBy = tooltipId;
        }

        return React.createElement(HotKeys, {
          keyMap: ACTION_KEY_MAP,
          handlers: this.hotKeyHandlers
        }, React.createElement(ToolTipWrapper, {
          tooltipClasses: tooltipClasses,
          onMouseOver: this._handleMouseOver,
          onMouseLeave: this._handleMouseLeave,
          onFocus: this._handleFocus,
          onBlur: this._handleBlur,
          onClickOutside: this._handleReset,
          describedBy: describedBy
        }, React.createElement(Component, componentProps), React.createElement(Tooltip, {
          tooltipId: tooltipId,
          targetNode: targetNode,
          arrowLocation: tooltipArrowLocation,
          style: tooltipStyle
        }, tooltipText)));
      }
    }]);

    return WithTooltipWrapper;
  }(PureComponent), _defineProperty(_class, "propTypes", {
    /**
     * The text to be set as id for tooltip
    **/
    tooltipId: PropTypes.string.isRequired,

    /**
     * The text or React element to be displayed.
     * If text is provided, it must be a label, no sentences, with a max character count of 32.
    **/
    tooltipText: TOOLTIP_CONTENT_PROPTYPE.isRequired,

    /**
     * Location of arrow for tooltip relative to targetNode. The direction chosen
     * relates to which side of the Tooltip the arrow will appear.
     * Options: left, right, top, bottom
    **/
    tooltipArrowLocation: ARROW_LOCATION_PROPTYPE,

    /**
     * The background color of the Tooltip. Options: basic, phab
    **/
    tooltipStyle: STYLE_PROPTYPE,
    __containerClassName: PropTypes.string
  }), _temp;
};

var ToolTipWrapper = onClickOutsideHOC(function (_ref) {
  var tooltipClasses = _ref.tooltipClasses,
      onMouseOver = _ref.onMouseOver,
      onMouseLeave = _ref.onMouseLeave,
      onFocus = _ref.onFocus,
      onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      describedBy = _ref.describedBy,
      children = _ref.children;
  return (
    /* Accessibility: This component does have key events, but not picked up by the linter becasue of the HOC */

    /* Ideally this component would be a button element but as it is a HOC, that has already been relased we can't do this. e.g. copy button with tooltip */

    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

    /* eslint-disable jsx-a11y/click-events-have-key-events */

    /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
    React.createElement("div", {
      className: tooltipClasses,
      onMouseOver: onMouseOver,
      onMouseLeave: onMouseLeave,
      onFocus: onFocus,
      onClick: onClick,
      onBlur: onBlur // `aria-describedby` is based on the <button> tag and not
      // with the component because in cases where component has
      // `aria-hidden` (i.e. <i> ), we still want `aria-describedby`
      // to be present and corresponds to the tooltip id
      ,
      "aria-describedby": describedBy,
      "data-spec": "tooltip-wrapper",
      tabIndex: "0",
      role: "tooltip"
    }, children)
  );
});
export default withTooltip;